// extracted by mini-css-extract-plugin
export var tweet = "tweet-module--tweet--3rk4-";